import { render, staticRenderFns } from "./TaxInvoiceSerialNumberAlert.vue?vue&type=template&id=04372058&scoped=true&"
import script from "./TaxInvoiceSerialNumberAlert.vue?vue&type=script&lang=ts&"
export * from "./TaxInvoiceSerialNumberAlert.vue?vue&type=script&lang=ts&"
import style0 from "./TaxInvoiceSerialNumberAlert.vue?vue&type=style&index=0&id=04372058&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04372058",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04372058')) {
      api.createRecord('04372058', component.options)
    } else {
      api.reload('04372058', component.options)
    }
    module.hot.accept("./TaxInvoiceSerialNumberAlert.vue?vue&type=template&id=04372058&scoped=true&", function () {
      api.rerender('04372058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/TaxInvoiceSerialNumberAlert.vue"
export default component.exports